type stateType = { lastUrl: string }

export const state = () => ({
  lastUrl: '',
})

export const mutations = {
  setLastUrl(state: stateType, url: string = '1') {
    state.lastUrl = url
  },
}

export const getters = {
  getLastUrl(state: stateType) {
    return state.lastUrl
  },
}
